import React, { FC, useCallback } from "react";
import { Box, InputGroup, InputLeftElement, Input } from "@chakra-ui/react";
import { FaSearch } from "react-icons/fa";
import { MdSearch } from "react-icons/md";
import { track, EVENTS } from "../../../utils/analytics";
import { useDebounce } from "../../../features/hooks";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  searchContext?: string; // Add a context identifier to know where the search is being used
}

const SearchInput: FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = "Search",
  searchContext = "generic",
}) => {
  // Track search with debounce to avoid excessive tracking
  const trackSearch = useCallback(
    useDebounce((searchTerm: string) => {
      if (searchTerm && searchTerm.trim().length > 2) {
        track(EVENTS.SEARCH.SEARCH_PERFORMED, {
          search_term: searchTerm,
          context: searchContext,
        });
      }
    }, 1000),
    [searchContext]
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange(newValue);
    trackSearch(newValue);
  };

  return (
    <Box pr="10px" pl="10px">
      <InputGroup>
        <InputLeftElement pointerEvents="none">
          <MdSearch fontSize="24px" color="gray" />
        </InputLeftElement>
        <Input
          placeholder={placeholder}
          border="1px solid var(--gray, #ccc)"
          pl="2rem" // space for icon
          value={value}
          onChange={handleChange}
        />
      </InputGroup>
    </Box>
  );
};

export default SearchInput;
